import { mergeAttributes, Node } from '@tiptap/core';

export enum CalloutTypes {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    callout: {
      callout: (options: { type: CalloutTypes }) => ReturnType;
    };
  }
}

const Callout = Node.create({
  name: 'callout',
  group: 'block',
  content: 'inline*',
  selectable: false,
  addOptions(): { type: CalloutTypes } {
    return {
      type: CalloutTypes.Info,
    };
  },
  parseHTML() {
    return [
      {
        tag: 'callout',
      },
    ];
  },

  addAttributes() {
    return {
      type: {
        default: CalloutTypes.Info,
        parseHTML: (element) => {
          const type = element.getAttribute('data-type');

          if (!type) {
            return CalloutTypes.Info;
          }

          return type as CalloutTypes;
        },
        renderHTML: (attributes) => {
          return {
            'data-type': attributes.type,
          };
        },
      },
      // this attribute is not rendering or saving to html but is used to show the dropdown on create
      showDropdownOnCreate: {
        default: false,
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['callout', mergeAttributes(HTMLAttributes), 0];
  },

  addCommands() {
    return {
      callout:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              ...options,
              showDropdownOnCreate: true,
            },
          });
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      // remove callout when at start of document or code block is empty
      Backspace: () => {
        const { empty, $anchor } = this.editor.state.selection;
        const isAtStart = $anchor.pos === 1;

        if (!empty || $anchor.parent.type.name !== this.name) {
          return false;
        }

        if (isAtStart || !$anchor.parent.textContent.length) {
          return this.editor.commands.clearNodes();
        }

        return false;
      },
    };
  },
});

export default Callout;
